import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isPast from 'date-fns/is_past';
import isAfter from 'date-fns/is_after';
import get from 'lodash/get';

import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import * as UserActions from 'rebook/apps/users/actions/UserActions';
import { parseApiDateTime } from 'rebook/apps/utils/datetime';

import MenuItemsList from './MenuItemsList';
import SubscriptionsInfo from './SubscriptionsInfo';
import styles from './style.scss';
import MENU_ITEMS from './constants';


const HeaderUserMenu = ({ user, onCloseMenu, ...props }) => {
  const userUrl = user && `/profile/${user.id}/`;
  const standardActiveTill = get(user, 'subscription_standard_active_till', null);
  const proActiveTill = get(user, 'subscription_pro_active_till', null);
  const audioActiveTill = get(user, 'subscription_audio_active_till', null);

  const isStandardLonger = isAfter(standardActiveTill, proActiveTill) && isAfter(standardActiveTill, audioActiveTill);
  const isStandardInPast = standardActiveTill !== null && isPast(standardActiveTill);

  // проверям, что премиум у пользователя относится только к аудио подписке
  const isOnlyAudioSubscription = (proActiveTill !== null && audioActiveTill !== null)
    && (proActiveTill === audioActiveTill);

  let subscriptionsArray = [
    { type: 'pro', dateTill: proActiveTill },
    { type: 'audio', dateTill: audioActiveTill },
  ];

  if (isStandardLonger || isStandardInPast) {
    subscriptionsArray.push({ type: 'standard', dateTill: standardActiveTill });
  }

  const allSubscriptionsOutdated = get(user, 'active_subscription_type', null) === null;
  const wasSubscribed = standardActiveTill || proActiveTill || audioActiveTill;
  let actualSubscriptionsList = [];
  let outdatedSubscriptionsList = [];

  for (let obj of subscriptionsArray) {
    const { dateTill, type } = obj;

    // если в массиве есть pro подписка и выполнено условие, что пользователь купил аудиоподписку
    // то не отображаем лишний блок с pro подпиской
    if (type === 'pro' && isOnlyAudioSubscription) {
      continue;
    }
    if (dateTill && !isPast(parseApiDateTime(dateTill))) {
      actualSubscriptionsList.push(obj);
    }
    else if (dateTill && isPast(parseApiDateTime(dateTill))) {
      outdatedSubscriptionsList.push(obj);
    }
  }

  return (
    <div className={classNames(styles.submenu, 'jest-header-user-menu')}>
      <div className={styles.submenuContainer}>
        <div className={styles.user}>
          <div className={styles.userConatiner}>
            <Link
              to={userUrl}
              className={styles.userLink}>
              {user.display_name}
            </Link>
          </div>
        </div>
        <div className={styles.menu}>
          <ul>
            <MenuItemsList items={MENU_ITEMS}
              pathname={props.pathname}
              onClickItem={onCloseMenu} />
          </ul>
        </div>
        {allSubscriptionsOutdated && (
          <Link className={styles.linkSubscription} to={'/payments/'} onClick={onCloseMenu}>
            Оформить подписку
          </Link>
        )}
        {!wasSubscribed && (
          <Link className={styles.linkSubscription} to={'/trial/'} onClick={onCloseMenu}>
          Получить 14 дней бесплатно
          </Link>
        )}

        {wasSubscribed && (
          <SubscriptionsInfo
            actualSubscriptionsList={actualSubscriptionsList}
            outdatedSubscriptionsList={outdatedSubscriptionsList} />
        )}
      </div>
      <div
        href="javascript:;"
        className={classNames(styles.logoutLink, 'jest-unauth-link-hamburger')}
        onClick={() => {
          ga('send', 'event', 'Logout');
          props.UserActions.unAuthenticateUser();
        }}>
        Выйти
      </div>
    </div>
  );
};

HeaderUserMenu.propTypes = {
  user: PropTypes.object,
};

HeaderUserMenu.defaultProps = {
  user: null,
};

function mapDispatchToProps(dispatch) {
  return {
    UserActions: bindActionCreators(UserActions, dispatch),
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(HeaderUserMenu);
